import { useMutation } from "react-query";
import { addRenewedAgreements } from "../../../../actions/CarrierAgreementMgmt/Agreements";

const useAddRenewedAgreements = () => {
  return useMutation(addRenewedAgreements);
};

export default useAddRenewedAgreements;
